import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  TextField,
  Grid,
} from '@material-ui/core'
import BaseDialog from '../../../BaseDialog'

import { useDataApi } from '../../../../context/DataApiContext'
import { useNotificationsProvider } from '../../../../context/NotificationsContext'

export default function ModifyVehicleTypeDialog({
  open,
  onClose,
  originalVehicleType,
  onModified,
}) {
  const { t } = useTranslation()

  const { dataProvider } = useDataApi()
  const { showNotification } = useNotificationsProvider()

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [brand, setBrand] = useState(null)
  const [model, setModel] = useState()

  const resetState = () => {
    // Clean form
    setLoading(false)
    setError('')
    setBrand('')
    setModel('')
  }

  useEffect(() => {
    if (!originalVehicleType) {
      return
    }

    setBrand(originalVehicleType.brand)
    setModel(originalVehicleType.model)
    // eslint-disable-next-line
  }, [originalVehicleType])

  const onCloseDialog = (event, reason) => {
    if ((reason === 'backdropClick') || (reason === 'escapeKeyDown')) {
      onClose()
    } else {
      resetState()
      onClose()
    }
  }

  const onConfirm = () => {
    if (brand.length === 0) {
      setError('brand_required')
      return
    }

    if (model.length === 0) {
      setError('model_required')
      return
    }

    const data = {
      brand,
      model,
    }
    setLoading(true)
    dataProvider.update('vehicle-type', { data, id: originalVehicleType.id }).then(() => {
      dataProvider.cache.reset()
      showNotification('success', t('modify-vehicle-type-dialog.success'))
      onModified()
    }).catch(() => {
      showNotification('error', t('errors.api-error'))
    }).then(() => resetState())
  }

  return (
    <BaseDialog
      open={open}
      onClose={onCloseDialog}
      onConfirm={onConfirm}
      title={t('modify-vehicle-type-dialog.title')}
      loading={loading}
      openButtonTitle={t('common.modify')}
    >
      <Grid container direction="column" spacing={4}>
        <Grid item>
          <TextField
            autoFocus
            required
            error={error === 'brand_required'}
            helperText={t('common.required')}
            id="brand"
            label={t('modify-vehicle-type-dialog.brand')}
            fullWidth
            value={brand}
            onChange={(event) => setBrand(event.target.value)}
          />
        </Grid>
        <Grid item>
          <TextField
            required
            error={error === 'model_required'}
            helperText={t('common.required')}
            id="model"
            label={t('modify-vehicle-type-dialog.model')}
            fullWidth
            value={model}
            onChange={(event) => setModel(event.target.value)}
          />
        </Grid>
      </Grid>
    </BaseDialog>
  )
}
